import { Gutter } from 'antd/lib/grid/row';
import { Gutter as ProGutter } from '@ant-design/pro-card/lib/type';

export const GUTTER: [Gutter, Gutter] = [
  { xs: 8, sm: 16 },
  { xs: 8, sm: 16 },
];

export const GUTTER_LARGE: [Gutter, Gutter] = [
  { xs: 16, sm: 32 },
  { xs: 16, sm: 32 },
];

export const PRO_GUTTER: [ProGutter, ProGutter] = [
  { xs: 8, sm: 16 },
  { xs: 8, sm: 16 },
];
